<template>
  <div :class="$style.container">
    <div :class="$style.containerLogo">
      <div div :class="$style.logoCuprum" @click="pushBack()">
        <img
          loading="lazy"
          src="@/assets/images/Cuprum_Logo_Positivo.svg"
          width="150"
          alt="logo_afp_cuprum"
        />
      </div>
    </div>
    <CreatePasswordForm/>
  </div>
</template>

<script>
import CreatePasswordForm from '@/components/CreatePasswordForm';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';

export default {
  name: 'CreatePassword',
  components: {
    CreatePasswordForm,
  },

  methods: {
    pushBack() {
      gtmRegister(constantsAnalytics.create.pageindex, this);
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" module>

.container {
  padding: 50px 300px;

  .containerLogo {
    cursor: pointer;
  }
}

@media (min-width: 500px) and (max-width: 1244px) {
  .container {
    padding: 50px 200px;
  }
}

@media (min-width: 500px) and (max-width: 920px) {
  .container {
    padding: 50px 100px;
  }
}

@media (max-width: 499px) {
  .container {
    padding: 50px 20px;
  }
}
</style>
